import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";
import { skillGroups } from "../../data/skills";
import { Reveal } from "../common/Reveal";
import { Icon } from "../common/Icon";
import "./Skills.css";

export function Skills() {
  const { t } = useLanguage();

  return (
    <section id="skills" className="section skills">
      <div className="container section-inner">
        <Reveal direction="up">
          <span className="eyebrow">{t.skills.eyebrow}</span>
          <h2 className="section-heading">{t.skills.heading}</h2>
          <p className="section-sub">{t.skills.subheading}</p>
        </Reveal>

        <div className="skills__grid">
          {t.skills.categories.map((category, ci) => (
            <Reveal direction="up" delay={0.06 * ci} key={category.id} className="skills__category">
              <div className="skills__category-head">
                <h3 className="skills__category-title">{category.title}</h3>
                <span className="skills__category-desc mono">{category.description}</span>
              </div>
              <div className="skills__badges">
                {skillGroups[category.id]?.map((skill, si) => (
                  <motion.span
                    className="skill-badge"
                    key={skill.name}
                    initial={{ opacity: 0, scale: 0.92 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: si * 0.04 }}
                    whileHover={{ y: -3 }}
                  >
                    <Icon icon={skill.icon} className="skill-badge__icon" />
                    <span className="mono">{skill.name}</span>
                  </motion.span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
